import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomerVoiceApiService } from '@vendasta/customer-voice-service';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { VstaticImageService } from '../core/vstatic-image.service';
import { SharedModule } from '../shared/shared.module';
import { ConfirmCustomerFormDialogComponent } from './confirm-dialog.component';
import { CustomerFacingComponent } from './customer-facing.component';
import { CustomerFormService } from './customer-facing.service';

const MaterialModules = [
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
];

@NgModule({
  imports: [MaterialModules, CommonModule, FormsModule, MatDialogModule, ReactiveFormsModule, SharedModule],
  declarations: [CustomerFacingComponent, ConfirmCustomerFormDialogComponent],
  exports: [CustomerFacingComponent],
  providers: [
    CustomerFormService,
    VstaticImageService,
    SnackbarService,
    ProductAnalyticsService,
    CustomerVoiceApiService,
  ],
})
export class CustomerFacingModule {}
